<template>
  <div class="sider">
    <el-menu router class="el-hcp-menu" :default-active="activePath" @open="handleOpen" :unique-opened="true">
      <el-submenu v-for="(item, i) in visibleRoutes" :index="item.path" :key="i">
        <template slot="title">
          <div class="subMenuTitle">
            <img :src="item.iconImg" alt="" class="icon" />
            <span>{{ formatName(item.name) }}</span>
          </div>
        </template>
        <div class="subMenu" v-if="item.children && item.children.length">
          <el-menu-item v-for="(subItem, subI) in item.children" :key="subI" :route="`/${item.path}/${subItem.path}`"
            :index="`/${item.path}/${subItem.path}`">
            {{ formatName(subItem.name) }}
          </el-menu-item>
        </div>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { constantRoutes } from "@/router/index";
import { createNamespacedHelpers } from "vuex";
const pagesHelper = createNamespacedHelpers("pages");
const authHelper = createNamespacedHelpers("auth");

export default {
  data() {
    return {
      constantRoutes,
      activePath: "",
    };
  },
  created() {
    this.getPath(this.$route.path);
  },
  watch: {
    "$route.path"(val) {
      this.getPath(val);
    },
  },
  computed: {
    ...pagesHelper.mapGetters(["visibleRoutes"]),
    ...authHelper.mapGetters(['isTeacher'])
  },
  methods: {
    formatName(str) {
      return typeof str === "string" ? str : this.$t(str())
    },
    getPath(val) {
      const arr = val && val.split("/");
      if (arr.length > 3) {
        this.activePath = `/${arr[1]}/${arr[2]}`;
      } else {
        this.activePath = val;
      }
    },
    handleOpen(index) {
      let target = constantRoutes.find((item) => item.path === index) || {}
      const { firstChildIndex } = target;
      const idx = firstChildIndex ? firstChildIndex({ isTeacher: this.isTeacher }) : 0
      let subPath = target.children[idx].path
      if (subPath) {
        this.$router.push(`/${index}/${subPath}`)
      }
    }
  },
};
</script>

<style lang="scss">
.el-hcp-menu.el-menu {
  width: 100%;
  border-right: 0;

  .el-submenu__title {
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #3377ff;
    font-weight: bold;
    margin-bottom: 4px;

    .el-icon-menu {
      color: #3377ff;
    }

    .el-submenu__icon-arrow {
      position: static;
      margin-top: 0;
      font-size: 20px;
      margin-left: 5px;
    }
  }

  .el-menu-item {
    height: 36px;
    line-height: 36px;
    text-align: center;
    border: 1px solid #cacdd6;
    border-radius: 3px;
    background: #f8f8f8;
    margin: 0 10px 5px;
    font-size: 16px;
    color: #a0a2ab;

    &.is-active {
      color: #3377ff;
      background: #f3f7ff;
      border: 1px solid #3377ff;
      font-weight: bold;
    }
  }
}
</style>
<style lang="scss" scoped>
.sider {
  flex: none;
  width: 222px;
  margin: 0 20px 150px;
  background-color: #fff;
  box-shadow: 0px 2px 16px 0px rgba(202, 205, 214, 0.47);
  border-radius: 6px;
}

.subMenuTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.icon {
  width: 16px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/Sider.vue